import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import App from '@/App'
import {getQuery} from '@/utils/getQuery'
const report = () => import('@/pages/report')
const componentNotFound = () => import('@/pages/404')

Vue.use(Router)
let router = new Router({
	mode: 'history',
	scrollBehavior(to, from, savedPosition) {
		return { x: 0, y: 0 }
	},
	routes: [
		{
			path: '/',
			component: App,
			children: [
				{
					path: '',
					name: 'report',
					component: report,
					beforeEnter: (to,from,next) => {
						document.querySelector('#loading').style.display = 'none'
						next()
					}
				}
			]
		},
		{
			//404 页面
			path: '*',
			component: componentNotFound,
			beforeEnter(to,from,next){
				document.querySelector('#loading').style.display = 'none'
				store.dispatch('SetLoading',false).then(()=>{
					next()
				})
			}
		}
	]
})
const getters = store.getters
router.beforeEach ( (to,from,next)=>{
	const token = getters.token || getQuery('accessToken',(token)=>{store.dispatch('SetToken',token)})
	const examInfoId = getters.examInfoId || getQuery('examInfoId',(examInfoId)=>{store.dispatch('SetExamId',examInfoId)})
	const userexamInfoTypeId = getters.examInfoType || getQuery('examInfoType',(userexamInfoTypeId)=>{store.dispatch('SetExamType',userexamInfoTypeId)})
	// if(!token || !examInfoId || !userexamInfoTypeId){
	// 	if(to.path==='/*'){next()}
	// 	else next('*')
	// }
	// else 
	next()
})
export default router


// WEBPACK FOOTER //
// ./src/router/index.js